import React from "react";

export default function Copyright() {
  return (
    <div className="flex items-center justify-center text-[0.7em] dark:text-white bg-[#0a192f] text-xs">
      All rights reserved by Steven 2022
    </div>
  );
}